<template>
  <div class="header">
    <div style="width: 24px;"></div>
    <h1>{{ title }}</h1>
    <router-link to="/" class="home-link">
      <i class="fas fa-home"></i>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'PageHeader',
  props: {
    title: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
.header {
  text-align: center;
  padding: 20px;
  background: #1e4c6b;
  color: white;
  margin-bottom: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 50px;
  padding-right: 50px;
}

.header h1 {
  flex: 1;
  text-align: center;
}

.home-link {
  color: white;
  text-decoration: none;
}

.home-link i {
  font-size: 24px;
  cursor: pointer;
}
</style> 